
export {SearchResultsManager};

import {e} from './utils.js';
import {PlayerMgr, PlayListMgr, ProgressBar, SearchGamesMgr, SearchOpsMgr, state} from './index.js';
import {AnchorDot} from './glyphs.js';
import {get_search_results} from './search.js';
import {ytplayerState} from './ytplayer.js';
import {PLAY_ALL_MONITOR, modifyPlayAllMonitor} from './setupmgr';
import {VID_PLAYLIST_URL} from './config.js';
import {DataTable} from './datatable.js';

// ---------------------------
// SEARCH RESULTS MANAGER
// ---------------------------

function SearchResultsManager() {

	var exportButton, exportModal, exportTextArea, playAllButton;

	(function () {

		playAllButton = $("<button />").text("Play All Video Clips");
		$("#results_page_buttons").append(playAllButton);

		$(playAllButton).on("click", function () {
			f_play_all();
		});

		$("#playlist_modal").easyModal();
		var playlistButton = $("<button />").text("Save Video Clips to Playlist");
		$("#results_page_buttons").append(playlistButton);

		exportButton = $("<button />").text("Show Individual Video Links");
		$("#results_page_buttons").append(exportButton);

		exportTextArea = $("<textarea />");
		exportTextArea.focus(function () {
			this.select();
			this.setSelectionRange(0, 9999);
		}).mouseup(function (el) {
			el.preventDefault();
		});

		exportModal = $("<div id='playlist_export_modal'/>");
		exportModal.append($("<p />").text("Click below to select all, then copy to your clipboard. (CTRL-c on Windows, CMD-c on Mac)"));
		exportModal.append(exportTextArea);

		exportModal.hide();
		$("#results_page").append(exportModal);

		$(exportButton).on("click", function () {
			if ($(exportModal).is(":visible")) {
				exportButton.text("Show Individual Video Links");
				$(exportModal).hide();
			} else {
				var data = ResultsTable.export_rows();
				$(exportTextArea).val(data);
				$(exportModal).show();
				exportButton.text("Hide Individual Video Links");
			}
		});

		$(playlistButton).on("click", function () {
			var data = ResultsTable.export_detailed_rows();

			var i, len;
			for (i=0, len=data.length; i < len; i++) {
				data[i].active = true;
			}

			$('#playlist_modal').trigger('openModal');

			$('#playlist_modal_cancel').off('click').click(function(){
				$('#playlist_modal').trigger('closeModal');
			});

			$('#playlist_modal_save').off('click').click(function(){
				var name = $('#playlist_modal_name').val();

				if (name.length) {
					var pkg = {
						uid: state.solouid,
						tid: e("selTeam").value,
						name: name,
						data: JSON.stringify(data)
					};

					$.ajax({
						type: 'POST',
						url: VID_PLAYLIST_URL,
						data: pkg,
						context: this
					}).done(function(result){
						if (result.status){
							alert('Unable to save playlist. ' + result.msg);
						} else {
							state.playlists.push({
								id: result.id,
								team: parseInt(e("selTeam").value),
								data: data,
								name: name,
								active: true
							});
							PlayListMgr.load_playlist_selector();
						}
						$('#playlist_modal').trigger('closeModal');
					}).fail(function(){
						alert('Unable to save playlist. Please try again later.');
					});
				}
			});
		});

	})();

	// ---------------------------
	// Properties
	// ---------------------------

	var ResultsTable = new DataTable(e("results_page"), "", true, true, this);

	// Add heads
	ResultsTable.add_head("playernum",  "int",   "",         "left",    0);
	ResultsTable.add_head("jerseynum",  "int",   "No.",      "left",    1);
	ResultsTable.add_head("playername", "str",   "Player",   "left",    4);
	ResultsTable.add_head("category",   "str",   "Category", "left",    2);
	ResultsTable.add_head("action",     "str",   "Action",   "left",    4);

	if (!state.touch) {
		ResultsTable.add_head("rotation", "int", "Rot", "center", 1);
	}

	ResultsTable.add_head("created", "date", "Date", "left", 2);

	if (state.touch) {
		ResultsTable.add_head("opponent", "str", "Event", "left", 2);
	} else {
		ResultsTable.add_head("opponent", "str", "Opponent", "left", 2);
	}

	if (state.touch) {
		ResultsTable.add_head("gamenum", "str", "Activity", "left", 2);
	} else {
		ResultsTable.add_head("gamenum", "int", "Game", "center", 1);
	}

	if (!state.touch) {
		ResultsTable.add_head("score", "score", "Score", "center", 1);
	}

	ResultsTable.add_head("vstate", "video", "Video", "center",  1);

	// ---------------------------
	// Functions
	// ---------------------------

	this.do_search    = f_do_search;
	this.row_selected = f_row_selected;
	this.clear_table  = f_clear_table;
	this.clear_export = f_clear_export;


	// ---------------------------
	// Methods
	// ---------------------------

	function f_do_search() {
		var players   = SearchOpsMgr.get_checked_players();
		var rotations = SearchOpsMgr.get_checked_rotations();
		var actions   = SearchOpsMgr.get_checked_actions();
		var games     = SearchGamesMgr.get_checked_games();

		if (players.length == 0)   { alert("You need to select at least one player.");   return "filter"; }
		if (!state.touch && rotations.length == 0) { alert("You need to select at least one rotation."); return "filter"; }
		if (games.length == 0)     { alert("You need to select at least one game.");     return "games"; }
		if (state.touch) {
			if ((actions.touch.length + actions.attack.length + actions.receive.length
				+ actions.defend.length + actions.set.length + actions.faults.length) == 0
			) {
				alert("You need to select at least one action, either touch, attack, receive, defend, or fault.");
				return "filter";
			}
		} else {
			if (actions.in_rally.length + actions.earned.length + actions.errors.length + actions.faults.length == 0) {
				alert("You need to select at least one action, either in-rally, earned, error, or fault.");
				return "filter";
			}
		}

		// Get the search results
		var Results = get_search_results(players, rotations, actions, games);

		// Fill the data table
		ResultsTable.load_data_async(Results, false, ProgressBar);

		// Update the results count
		e("num_results").innerHTML = Results.length + " Results";

		// Return
		return "results";
	}

	function f_clear_table() {
		ResultsTable.clear_all_rows();
	}

	function f_clear_export() {
		$(exportModal).hide();
	}

	function f_row_selected(r) {
		// Play the video
		if (r.dataobj.vid === null) {
			e("novideo").style.visibility = "visible";
			e("novideo").style.display    = "block";
			PlayerMgr.pause_video();
		} else {
			e("novideo").style.visibility = "hidden";
			e("novideo").style.display    = "none";
			PlayerMgr.play_clip(r.dataobj.vid, r.dataobj.vstart, r.dataobj.vend - r.dataobj.vstart);
		}
	}

	function f_play_all() {
		if (!PLAY_ALL_MONITOR) {
			var firstRow = $('#results_page .data_table_rows').first().children().first()[0];

			var data = $(firstRow)[0].dataobj;
			var startRow = $(firstRow);

			if ((data.vid === null) || (data.vstart < 0) && (data.vend < 0)) {
				var nextRows = $(firstRow).nextAll();
				nextRows.each(function (index, row) {
					if ((data.vid === null) || (data.vstart < 0) && (data.vend < 0)) {
						var vstate = $(row)[0].dataobj.vstate;
						if (vstate == AnchorDot.STATE_ANCHOR || vstate == AnchorDot.STATE_RELATIVE) {
							data = $(row)[0].dataobj;
							startRow = $(row);
						}
					}
				});
			}

			startRow.trigger("click");

			if ((data.vid !== null) && (data.vstart >= 0) && (data.vend >= 0)) {
				$("button:contains('Play All Video Clips')").text('Stop All Video Clips');
				modifyPlayAllMonitor(window.setInterval(f_play_next, 500));
			}
		} else {
			window.clearInterval(PLAY_ALL_MONITOR);
			modifyPlayAllMonitor(null);
			PlayerMgr.stop_clip();
			$("button:contains('Stop All Video Clips')").text('Play All Video Clips');
		}
	}

	function f_play_next() {
		var currentRow = ResultsTable.get_sel_row();
		var currentRowData = $(currentRow)[0].dataobj;

		var nextRows = $(currentRow).nextAll();
		var nextRow = null;
		var nextRowData = null;
		nextRows.each(function (index, row) {
			if (nextRowData === null) {
				var vstate = $(row)[0].dataobj.vstate;
				if (vstate == AnchorDot.STATE_ANCHOR || vstate == AnchorDot.STATE_RELATIVE) {
					nextRow = row;
					nextRowData = $(row)[0].dataobj;
				}
			}
		});

		var currentTime = ytplayerState.yt_player.getCurrentTime();

		if (nextRow && nextRowData) {
			if (currentTime >= currentRowData.vend || (nextRowData.vstart > currentRowData.vstart && currentTime >= nextRowData.vstart)) {
				$(nextRow).trigger("click");
			}
		} else if (currentTime >= currentRowData.vend) {
			window.clearInterval(PLAY_ALL_MONITOR);
			modifyPlayAllMonitor(null);
			PlayerMgr.pause_clip();
			$("button:contains('Stop All Video Clips')").text('Play All Video Clips');
		}
	}
}

